/**
 * When true, subscription CRUD mirrors to the API (see db.ts).
 * Set from App after a successful /v1/me response.
 */
let cloudSessionActive = false;

export function setCloudSessionActive(active: boolean): void {
  cloudSessionActive = active;
}

export function isCloudSessionActive(): boolean {
  return cloudSessionActive;
}
